import { IconWrapper } from "@insite/mobius/Icon";
import { OverflowMenuPresentationProps } from "@insite/mobius/OverflowMenu";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { colorPalette, colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const overflowMenu: RecursivePartial<{
    defaultProps?: OverflowMenuPresentationProps | undefined;
}> = {
    defaultProps: {
        buttonProps: {
            hoverStyle: {
                backgroundColor: `${getColor(colorStrings.primaryMain)}33`,
                border: "none",
            },
            mergeCss: true,
            css: css`
                ${IconWrapper} {
                    color: ${getColor(colorStrings.primaryMain)};
                }

                &:hover,
                &:focus {
                    background-color: ${getColor(colorStrings.primaryMain)};
                    border-radius: 50%;

                    ${IconWrapper} {
                        color: ${getColor(colorStrings.commonGlobalWhite)};
                    }
                }
            `,
        },
        iconProps: {
            css: css`
                color: ${getColor(colorStrings.primaryMain)};

                &:hover,
                &:focus {
                    color: ${getColor(colorStrings.commonGlobalWhite)};
                }
            `,
        },
        mergeCss: true,
        cssOverrides: {
            wrapper: css`
                button,
                [data-test-selector="popoverOverflowTrigger"] {
                    min-height: auto;
                    width: 40px;
                    height: 40px;

                    ${mediaQueriesBP.minLG} {
                        width: 50px;
                        height: 50px;
                    }

                    ${IconWrapper} {
                        color: ${getColor(colorStrings.primaryMain)};
                    }

                    &:hover,
                    &:focus {
                        background-color: ${getColor(colorStrings.primaryMain)};
                        border-radius: 50%;
                        outline: none;

                        ${IconWrapper} {
                            color: ${getColor(colorStrings.commonGlobalWhite)};
                        }
                    }
                }
            `,

            menuItem: css`
                &:hover {
                    border-radius: 0;
                    background-color: ${getColor(colorStrings.primaryMain)}22;
                }
            `,
        },
    },
};
